import { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapLineMode } from "mapbox-gl-draw-snap-mode";

import { removeGuides } from "./helper";

const drawLineString: DrawCustomMode = {
  ...SnapLineMode,

  onSetup: function (opts) {
    const state = SnapLineMode.onSetup?.call(this, opts);
    removeGuides.call(this);

    return state;
  },
};

export default drawLineString;
